module.exports = __webpack_public_path__ + "28a1aa93077d0c55e42139ef48d4b475.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/harpers-bazaar/harpers-bazaar-bride-2015-2.jpg
 ** module id = 463
 ** module chunks = 0
 **/